<template>
  <div>
    <NuxtLink :to="appLink(['dictionary', slug])">
      <span class="f-utility-16-medium t-fg-primary">{{ title }}</span>
    </NuxtLink>
    <p v-if="content" class="f-utility-14 t-fg-primary mt-12">{{ content }}</p>
    <p-divider v-if="divider" class="my-16" />
    <div v-else class="my-32"></div>
  </div>
</template>

<script setup lang="ts">
import { useAppLink } from '@/composables/useAppLink'

const { appLink } = useAppLink()

defineProps({
  title: {
    type: String,
    required: true,
  },
  content: {
    type: String,
    default: '',
    required: false,
  },
  slug: {
    type: String,
    default: '#',
    required: false,
  },
  divider: {
    type: Boolean,
    default: false,
  },
})
</script>
